import type { ReactElement } from 'react';
import { formatNumber } from '@xdocs/i18n';
import { useI18n, cn } from '@xdocs/ui';
import type { AdminUserDetail } from '@xdocs/schemas';
import { useAdminT } from '../../../../features/admin/index.js';
import styles from './CreditsTab.module.css';

export interface CreditsTabProps {
  detail: AdminUserDetail;
}

/** F19/F54 credits read view — the live authority
 * (`users.credits_balance`, never cached). The `+N`/`−N` adjustment itself
 * lives in `ProfileTab`'s "Adjust credits" action (one trigger, not
 * duplicated per tab). */
export function CreditsTab({ detail }: CreditsTabProps): ReactElement {
  const { locale } = useI18n();
  const { t } = useAdminT();

  return (
    <div className={cn(styles['panel'])}>
      <div className={cn(styles['balanceRow'])}>
        <span className={cn(styles['balance'])}>{formatNumber(locale, detail.user.creditsBalance)}</span>
        <span className={cn(styles['balanceLabel'])}>{t('admin:userDetail.credits.label')}</span>
      </div>
      <p className={cn(styles['note'])}>{t('admin:userDetail.credits.historyUnavailable')}</p>
    </div>
  );
}
